export enum RecordState {
  INSERT = 'I',
  UPDATE = 'U',
  DELETE = 'D',
  NONE = '',
}

export enum RegisterState {
  SUCCESS,
  FAILURE,
  PARTIAL_FAILURE,
  NONE,
}

export enum Condition1 {
  ALL = '1',
  PRODUCT = '2',
  CONFIGURATION = '3',
  HINMEI = '4',
}

export enum FieldLength {
  SHORT = 'w-[180px]',
  MIDDLE = 'w-[280px]',
  LONG = 'w-[460px]',
}
export enum Delimiter {
  HYPHEN = '-',
  ARROW = '←',
}
